import {takeLatest, put, select} from 'redux-saga/effects';
import getCustomerInsightsApi from 'helpers/services/api/customerInsights';
import {
  GET_CUSTOMER_INSIGHTS,
  GET_CUSTOMER_INSIGHTS_ERROR,
  GET_CUSTOMER_INSIGHTS_SUCCESS,
  SET_CUSTOMER_INSIGHTS_LOADING
} from 'store/customerInsights/action';

function* getCustomerInsights({payload}) {
  try {
    yield put(SET_CUSTOMER_INSIGHTS_LOADING(true));

    const locationId = yield select((state) => state.user?.activeLocation?._id);

    if (!locationId) {
      yield put(SET_CUSTOMER_INSIGHTS_LOADING(false));
      return;
    }

    const response = yield getCustomerInsightsApi(locationId, payload || {});
    yield put(GET_CUSTOMER_INSIGHTS_SUCCESS(response?.data?.data || null));
    yield put(SET_CUSTOMER_INSIGHTS_LOADING(false));
  } catch (error) {
    yield put(GET_CUSTOMER_INSIGHTS_ERROR(error));
    yield put(SET_CUSTOMER_INSIGHTS_LOADING(false));
    console.log('CUSTOMER INSIGHTS SAGA ERROR', error);
  }
}

function* customerInsightsSaga() {
  yield takeLatest(GET_CUSTOMER_INSIGHTS, getCustomerInsights);
}

export default customerInsightsSaga;
